/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CreateReportModal_viewer = {
    readonly company: {
        readonly isUsingProjectAllocation: boolean | null;
        readonly isUsingSchedulingPlanMode: boolean | null;
        readonly isUsingMixedAllocation: boolean | null;
        readonly sageIntacctTimeRegsFromForecast: boolean | null;
        readonly sageIntacctEnabled: boolean | null;
    } | null;
    readonly " $refType": "CreateReportModal_viewer";
};
export type CreateReportModal_viewer$data = CreateReportModal_viewer;
export type CreateReportModal_viewer$key = {
    readonly " $data"?: CreateReportModal_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"CreateReportModal_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateReportModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingProjectAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingSchedulingPlanMode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingMixedAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctTimeRegsFromForecast",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '250155e2c0b69c7a166b606454fd8f40';
export default node;
